<mat-form-field appearance="outline" class="input-form">
  <mat-label>
    {{ txtLabel }}
  </mat-label>

  <input
    matInput
    #inputpicker
    [ngxMatDatetimePicker]="picker"
    [formControl]="formDate"
    (dateChange)="emitDate($event)"
    placeholder="{{ txtPlaceholder }}"
  />

  <mat-datepicker-toggle matSuffix [for]="$any(picker)">
  </mat-datepicker-toggle>

  <ngx-mat-datetime-picker #picker [hideTime]="hideTime">
  </ngx-mat-datetime-picker>
</mat-form-field>
